import { ApolloError } from '@apollo/client';

export const getErrorCode = (e: ApolloError) => {
    if (e.graphQLErrors && e.graphQLErrors.length > 0) {
        return e.graphQLErrors[0].extensions?.code as string || '';
    }
    return '';
};
